//import React, { FunctionComponent, useState, useEffect } from 'react';
import React, { FunctionComponent } from 'react';
//1) Définir 1 variable d'état nommé 'Pokemon' dans le composant 'App.tsx'
//import Pokemon from './models/pokemon';
//2) Initialiser cet état avec la liste des Pokemons contenu dans la constante 'Pokemnon'
//import POKEMONS from './models/mock-pokemon';
import PokemonList from './pages/pokemon-list';
import PokemonDetail from './pages/pokemon-detail';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import PageNotFound from './pages/page-not-found';
import PokemonEdit from './pages/pokemon-edit';
import PokemonAdd from './pages/pokemon-add';
import Login from './pages/login';
import PrivateRoute from './PrivateRoute';

//3) Typer cet état Pokemon afin qu'il contienne 1 tableau de Pokemons
const App: FunctionComponent = () => {
 //const [pokemons, setPokemons] = useState<Pokemon[]>([]);


/*
useEffect(() => {*/
    /*PokemonsAPI.getPokemons(currentUserId).then(pokemons => setPokemons(pokemons));
}, []) //tableau vide correspond au componentDidMount()*/
/*    setPokemons(POKEMONS);
}, []);
*/

/*
return (
    <div>
        <h1 className="center">Pokédex</h1>
        <div className="container">
            <div className="row">
            {pokemons.map(({id, name, picture, created}) => (
                <div className="col s6 m4" key={id}>
                <div className="card horizontal">
                    <div className="card-image">
                    <img src={picture} alt={name}/>
                    </div>
                    <div className="card-stacked">
                    <div className="card-content">
                        <p>{name}</p>
                        <p><small>{created.toString()}</small></p>      
                    </div>
                    </div>
                </div>
                </div>    
            ))}
            </div>        
        </div>
    </div>
 )
}
*/

/*return (
    <PokemonList />
 )
*/

return (
    <Router>
        <div>
            {/* La barre de navigation à toutes les pages */}
            <nav>
                <div className="nav-wrapper teal">
                    <Link to="/" className="brand-logo center">Pokédex</Link> 
                </div>    
            </nav>
             {/* Le système de gestion des routes de notre application */}
             <Switch>
               <PrivateRoute exact path="/" component={PokemonList} />
               <Route exact path="/login" component={Login} />
               <PrivateRoute exact path="/pokemons" component={PokemonList} />
               <PrivateRoute exact path="/pokemon/add" component={PokemonAdd} />
               <PrivateRoute exact path="/pokemons/edit/:id" component={PokemonEdit} />
               <PrivateRoute path="/pokemons/:id" component={PokemonDetail} />               
               <Route component={PageNotFound} />    
             </Switch> 
        </div>
    </Router>
)
}

export default App;